import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  forgotPasswordEmail,
  validateForgotPasswordEmail,
} from '../password-dialog/password-dialog.validation';

@Component({
  selector: 'gep-forgot-password',
  imports: [ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: '../password-dialog/password-dialog.css',
})
export class ForgotPasswordComponent implements AfterViewInit {
  private readonly activeModal = inject(NgbActiveModal);

  @ViewChild('emailInput')
  emailInput?: ElementRef<HTMLInputElement>;

  readonly email = new FormControl('', { nonNullable: true });
  validationMessage = '';

  ngAfterViewInit(): void {
    this.emailInput?.nativeElement.focus();
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  confirmFromEnter(event: Event): void {
    event.preventDefault();
    this.confirm();
  }

  confirm(): void {
    const message = validateForgotPasswordEmail(this.email.value);
    if (message) {
      this.validationMessage = message;
      return;
    }

    this.validationMessage = '';
    this.activeModal.close(forgotPasswordEmail(this.email.value));
  }
}
